import React from 'react';
import './styles.css';

type NumbersInputUITypes = 'standart' | 'box';

interface Props {
  value?: number;
  setValue: (amount?: number) => void;
  disabled?: boolean;
  fieldError?: boolean;
  uiType?: NumbersInputUITypes;
  heading?: string;
  isMandatory?: boolean;
  className?: string;
  minValue?: number;
  maxValue?: number;
}

const NumbersInput = React.memo(
  ({
    value,
    setValue,
    disabled,
    fieldError,
    uiType,
    heading,
    isMandatory,
    className,
    minValue,
    maxValue,
  }: Props) => {
    const onArrowUp = () => {
      if (disabled) return;
      let result = 0;
      const max = maxValue ? maxValue : 100;
      if (value !== undefined) {
        result = value + 1;
      }
      if (result <= max) {
        setValue(result);
      }
    };

    const onArrowDown = () => {
      if (disabled) return;
      let result = 0;
      const min = minValue ? minValue : 0;
      if (value !== undefined) {
        result = value - 1;
      }
      if (result >= min) {
        setValue(result);
      }
    };

    const onInputChange = (e: any) => {
      if (e.target.value !== '') {
        const min = minValue ? minValue : 0;
        const max = maxValue ? maxValue : 100;
        if (
          parseInt(e.target.value, 10) <= max &&
          parseInt(e.target.value, 10) >= min
        ) {
          setValue(parseInt(e.target.value, 10));
        }
        if (parseInt(e.target.value, 10) >= max) {
          setValue(max);
        }
        if (parseInt(e.target.value, 10) <= min) {
          setValue(min);
        }
      } else {
        setValue(minValue);
      }
    };

    const getBaseClass = () => {
      switch (uiType) {
        case 'box':
          return 'NumbersInputBoxContainer';
        default:
          return 'NumbersInputStandart';
      }
    };

    return (
      <div className={`${className} ${disabled ? 'NumbersInputDisabled' : ''}`}>
        <p className="NumbersInputTitle">
          {heading}
          {isMandatory ? <span className="MandatoryIndicator">*</span> : ''}
        </p>
        <div
          className={`NumbersInputContainer ${getBaseClass()} ${
            fieldError ? 'NumbersInputFieldError' : ''
          }`}>
          <input
            type="number"
            value={value}
            disabled={disabled}
            onChange={onInputChange}
          />
          <div className="Divider" />
          <div className="ButtonsContainer">
            <button onClick={onArrowUp}>
              <span className="icon-chevron-up" />
            </button>
            <button onClick={onArrowDown}>
              <span className="icon-chevron-down" />
            </button>
          </div>
        </div>
      </div>
    );
  },
);

export default NumbersInput;
